import { isNil } from 'ramda'

import type { LinkUrl } from '@twisto/api-cms'

export const appendSearchParams = (
  url: string | undefined,
  search: string
): string | undefined => {
  if (!url || !search) {
    return url
  }

  return `${url}${url.includes('?') ? '&' : '?'}${search}`
}

// Extract url from page reference if exists
export const getLinkUrl = (link: LinkUrl): string | undefined => {
  if (isNil(link)) {
    return link
  }

  if (!isNil(link.page)) {
    return link.page.path
  }

  if (!isNil(link.category)) {
    return link.category.path ?? ''
  }

  if (!isNil(link.article)) {
    return link.article.path ?? ''
  }

  if (!isNil(link.url)) {
    return link.url
  }

  return ''
}
